import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetFavoriteListingType, TSetFavoriteListingType } from './types';
import { ISettings } from '../../../types/settings';

export const setFavoriteListingType: (type: ISettings['favoriteListingType']) => TSetFavoriteListingType =
  actionGenerator<ESetFavoriteListingType.Set, ISettings['favoriteListingType']>(ESetFavoriteListingType.Set);
